{
  "version": 1,
  "asset_id": "0c0bf46e-98e9-4978-9d3f-f4e99373442f",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/0c0bf46e-98e9-4978-9d3f-f4e99373442f/thumb-garden.webp",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/0c0bf46e-98e9-4978-9d3f-f4e99373442f/thumb-garden.webp",
  "original_filename": "thumb-garden.webp",
  "size": 177796,
  "content_type": "image/webp",
  "created_at": "2026-08-30T13:03:30Z"
}
